import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatOption, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelect, MatSelectTrigger} from '@angular/material/select';
import {RouterModule} from '@angular/router';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {TranslateModule} from '@ngx-translate/core';
import {CommonsModule} from '@npck/libs/commons';
import {CodeInputModule} from 'angular-code-input';
import {ClipboardModule} from 'ngx-clipboard';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AppVersionComponent} from './components/app-version/app.version.component';
import {BreadcrumbsComponent} from './components/breadcrumbs/breadcrumbs.component';
import {ButtonComponent} from './components/button/button.component';
import {CalendarComponent} from './components/calendar/calendar.component';
import {CustomCalendarHeaderComponent} from './components/calendar/custom-calendar-header/custom-calendar-header.component';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {CodeInputComponent} from './components/code-input/code-input.component';
import {CopyButtonComponent} from './components/copy-button/copy-button.component';
import {DateRangePickerComponent} from './components/date-range-picker/date-range-picker.component';
import {DialogComponent} from './components/dialog/dialog.component';
import {EmptyStateComponent} from './components/empty-state/empty-state.component';
import {ErrorPanelComponent} from './components/error-panel/error-panel.component';
import {ErrorComponent} from './components/error/error.component';
import {FilterFieldComponent} from './components/filter-field/filter-field.component';
import {LanguageToggleComponent} from './components/language-toggle/language-toggle.component';
import {PublicLinkComponent} from './components/public-link/public-link.component';
import {SelectionItemGroupComponent} from './components/selection-list/selection-item/selection-item-group.component';
import {SelectionItemComponent} from './components/selection-list/selection-item/selection-item.component';
import {SelectionListComponent} from './components/selection-list/selection-list.component';
import {SidebarDialogContentHostComponent} from './components/sidebar-dialog/host/sidebar-dialog-content-host.component';
import {SidebarDialogComponent} from './components/sidebar-dialog/sidebar-dialog.component';
import {SnackbarComponent} from './components/snackbar/snackbar.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {StepperComponent} from './components/stepper/stepper.component';
import {SvgComponent} from './components/svg/svg.component';
import {SwitchComponent} from './components/switch/switch.component';
import {TimerComponent} from './components/timer/timer.component';
import {TimerFormatPipe} from './components/timer/timer.pipe';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {DialogService} from './service/dialog.service';
import {SnackbarService} from './service/snackbar.service';

@NgModule({
    imports: [
        CommonModule,
        CommonsModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MatRippleModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        RouterModule,
        MatDialogModule,
        TranslateModule,
        NgxSpinnerModule.forRoot({type: 'ball-fussion'}),
        MatOption,
        MatSelect,
        MatSelectTrigger,
        ClipboardModule,
        CodeInputModule
    ],
    declarations: [
        ButtonComponent,
        SpinnerComponent,
        TimerComponent,
        TimerFormatPipe,
        SvgComponent,
        LanguageToggleComponent,
        CalendarComponent,
        ClickOutsideDirective,
        CheckboxComponent,
        DialogComponent,
        PublicLinkComponent,
        SnackbarComponent,
        BreadcrumbsComponent,
        CustomCalendarHeaderComponent,
        EmptyStateComponent,
        AppVersionComponent,
        ErrorPanelComponent,
        DateRangePickerComponent,
        ErrorComponent,
        StepperComponent,
        CodeInputComponent,
        CopyButtonComponent,
        SwitchComponent,
        SidebarDialogComponent,
        SidebarDialogContentHostComponent,
        SelectionListComponent,
        SelectionItemComponent,
        SelectionItemGroupComponent,
        FilterFieldComponent,
    ],
    exports: [
        ButtonComponent,
        SpinnerComponent,
        TimerComponent,
        TimerFormatPipe,
        SvgComponent,
        LanguageToggleComponent,
        CalendarComponent,
        ClickOutsideDirective,
        CheckboxComponent,
        DialogComponent,
        PublicLinkComponent,
        SnackbarComponent,
        BreadcrumbsComponent,
        CustomCalendarHeaderComponent,
        EmptyStateComponent,
        AppVersionComponent,
        ErrorPanelComponent,
        DateRangePickerComponent,
        ErrorComponent,
        StepperComponent,
        CodeInputComponent,
        CopyButtonComponent,
        SwitchComponent,
        SidebarDialogComponent,
        SelectionListComponent,
        SelectionItemComponent,
        SelectionItemGroupComponent,
        FilterFieldComponent,
    ],
    providers: [DialogService, SnackbarService],
})
export class UiKitModule {
}
